
<h3 tabindex="0" style="padding: 0 1rem;">Selected Note Title: {{data.title}}</h3>
<div style="padding: 0 1rem 1rem;"> 
  <span tabindex="0">You are about to delete an analysis note. Are you sure you want to proceed?</span>  
  <div class="button-box">
    <button (click)="onConfirmDelete()" class="primary-button">Yes</button>
    <button (click)="onClickCancelDelete()" class="secondary-button">No</button>
  </div>
</div>
